/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-no-bind */
import React, { useState, useEffect } from 'react';
// import Link from 'next/link';
import Image from 'next/image';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';
import { Modal } from '@madeeasy/universal-login';
import PropTypes from 'prop-types';
import { useSearchParams, usePathname } from 'next/navigation';
import DatePlace from '../date-place';
import videoIcon from '../../../public/assets/videoIcon.png';
import speakerIcon from '../../../public/assets/speakerIcon.png';
import promoEventBanner from '../../../public/assets/webinarSeminarPromoBg.png';
import HomeTopSlider from '../home/slider/HomeTopSlider';
import BenifitCard from '../benifit-card';
import FAQSection from '../faq/faq-section';
import banner from '../../../public/assets/aboutBanner.png';
import HorizontalScroll from '../shared/HorizontalScroll';
import CountDownTimer from '../countdown-timer';
import Carousel from '../carousel';
import PROMOTIONAL_EVENT_REGISTER_EVENT from '../../gql/mutations/promotional-event-register.gql';
import ErrorMessage from '../shared/error-fetching';
import SuccessFormPopup from '../profile/forms/SuccessFormPopup';
import NoDataFound from '../shared/NoDataFound';
import { useUser } from '../../contexts/ssr-user-context';
import EventNames from '../../utils/event-name-constants';
import { trackEvent } from '../../utils/analytics';

function EventRegisterForm({ data }) {
  const [showLogin, setShowLogin] = useState(false);
  const [timer, setTimer] = useState(false);
  const [isFormShow, setIsFormShow] = useState(false);
  // const [formFields, setFormFields] = useState();
  const [status, setStatus] = useState();
  const [isPopupOpen, setPopupOpen] = useState(false);
  const { user } = useUser();
  const noMsg = 'No Event found';
  // eslint-disable-next-line no-unused-vars
  const [eventType, setEventType] = useState(data?.getPromotionalEventBySlug?.type);
  const isLoggedIn = user?.id;
  const [isUserAlreadyRegistered, setIsUserAlreadyRegistered] = useState(data?.getPromotionalEventBySlug?.isAccountRegistered);
  const [registerForAcademicEvent, { loading: mutationLoading, error: mutationError }] = useMutation(PROMOTIONAL_EVENT_REGISTER_EVENT);
  const { PROMOTIONAL_PAGE_VIEWED, PROMOTIONAL_EVENT_REGISTER, PROMOTIONAL_EVENT_STARTED } = EventNames;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const slug = data?.getPromotionalEventBySlug?.slug;

  useEffect(() => {
    if (eventType === 'webinar') {
      trackEvent(PROMOTIONAL_PAGE_VIEWED, {
        link: data?.getPromotionalEventBySlug?.link,
        webinarId: data?.getPromotionalEventBySlug?.id,
        webinarTitle: data?.getPromotionalEventBySlug?.name,
        webinarType: data?.getPromotionalEventBySlug?.type,
      });
    }
  }, []);

  function domainBaseUrl() {
    return window.location.origin;
  }

  useEffect(() => {
    const now = new Date();
    const eventStartLocal = new Date(data?.getPromotionalEventBySlug?.startDate);
    const timeToStart = eventStartLocal.getTime() - now.getTime();
    if (isUserAlreadyRegistered && isLoggedIn && timeToStart > 0) {
      setStatus('Registered');
    } else if (isUserAlreadyRegistered && isLoggedIn && timeToStart <= 0) {
      if (data?.getPromotionalEventBySlug?.type === 'webinar') {
        setStatus('Join Now');
      } else {
        setStatus('Registered');
      }
    } else {
      setStatus('Register Now');
    }
  }, [data]);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const handleRegisterEvent = async (formfields = []) => {
    try {
      const result = await registerForAcademicEvent({
        variables: {
          input: {
            promotionalEventId: data?.getPromotionalEventBySlug?.id,
            formFields: formfields || [],
          },
        },
      });

      if (result) {
        trackEvent(PROMOTIONAL_EVENT_REGISTER, {
          webinarId: data?.getPromotionalEventBySlug?.id,
          webinarTitle: data?.getPromotionalEventBySlug?.name,
          webinarType: data?.getPromotionalEventBySlug?.type,
        });
        setPopupOpen(true);
        const now = new Date();
        const eventStartLocal = new Date(data?.getPromotionalEventBySlug?.startDate);
        const timeToStart = eventStartLocal.getTime() - now.getTime();
        setIsUserAlreadyRegistered(true);
        if (timeToStart <= 0) {
          if (data?.getPromotionalEventBySlug?.type === 'webinar') {
            setStatus('Join Now');
          } else {
            setStatus('Registered');
          }
        } else {
          setStatus('Registered');
        }
      }
    } catch (err) {
      if (err) {
        console.error('Mutation error:', err);
      }
    }
  };

  const handleRedirect = () => {
    const encodeUrl = encodeURIComponent(`${domainBaseUrl()}/prep/event/${slug}`);
    const params = new URLSearchParams(searchParams.toString());
    params.set('redirectTo', encodeUrl);
    const newUrl = `${pathname}?${params.toString()}`;
    window.history.replaceState(null, '', newUrl);
  };

  const handleRegister = () => {
    if (status === 'Register Now') {
      if (isLoggedIn && !isUserAlreadyRegistered) {
        if (data?.getPromotionalEventBySlug?.formFields.length > 0) {
          setIsFormShow(true);
        } else {
          setIsFormShow(false);
          handleRegisterEvent();
        }
      } else if (!isLoggedIn) {
        handleRedirect();
        setShowLogin(true);
      }
    }
    if (status === 'Registered') {
      return;
    }
    if (status === 'Event Ended') {
      return;
    }
    if (data?.getPromotionalEventBySlug?.type === 'webinar') {
      if (status === 'Join Now') {
        if (!isLoggedIn && !isUserAlreadyRegistered) {
          setShowLogin(true);
        } else if (isLoggedIn && isUserAlreadyRegistered) {
          if (data?.getPromotionalEventBySlug?.link) {
            trackEvent(PROMOTIONAL_EVENT_STARTED, {
              webinarId: data?.getPromotionalEventBySlug?.id,
              webinarTitle: data?.getPromotionalEventBySlug?.name,
              webinarType: data?.getPromotionalEventBySlug?.type,
            });
            window.location.href = data?.getPromotionalEventBySlug?.link;
          }
        } else if (isLoggedIn && !isUserAlreadyRegistered) {
          if (data?.getPromotionalEventBySlug?.formFields.length > 0) {
            setIsFormShow(true);
          } else {
            setIsFormShow(false);
            handleRegisterEvent();
          }
        }
      }
    }
  };

  function toggleModal() {
    setShowLogin(false);
  }

  const startTimer = async () => {
    const now = new Date();
    const eventStartLocal = new Date(data?.getPromotionalEventBySlug?.startDate);
    const eventEndLocal = new Date(data?.getPromotionalEventBySlug?.endDate);
    const timeToStart = eventStartLocal.getTime() - now.getTime();
    const timeToEnd = eventEndLocal.getTime() - now.getTime();
    if (timeToEnd <= 0) {
      setTimer(false);
      setStatus('Event Ended');
    }

    if (timeToStart <= 0 && timeToEnd > 0) {
      setTimer(false);
      if (eventType === 'webinar') {
        setStatus('Join Now');
      }
    }

    if (timeToStart > 0 && timeToStart <= 24 * 60 * 60 * 1000) {
      setTimer(true);
    } else {
      setTimer(false);
    }
  };

  useEffect(() => {
    startTimer();
    const interval = setInterval(startTimer, 1000);

    return () => clearInterval(interval);
  }, []);

  const handleTimer = (isEnd) => {
    if (isEnd === 'ended') {
      setStatus('Join Now');
      setTimer(false);
    } else {
      // console.log('started');
    }
  };

  const onSubmit = async (field) => {
    try {
      if (Object.keys(field).length !== 0) {
        const input = Object.entries(field).map(([key, value]) => ({
          key,
          value,
        }));
        // setFormFields(input);
        setIsFormShow(false);
        handleRegisterEvent(input);
        reset();
      }
    } catch (err) {
      console.log('Error processing form fields:', err);
    }
  };

  const handleClose = async () => {
    setIsFormShow(false);
    reset();
  };

  if (mutationError) {
    return (
      <ErrorMessage error={mutationError.message} fullPage />
    );
  }
  return (
    <>
      {
        isFormShow && data?.getPromotionalEventBySlug?.formFields?.length > 0 && (
          <div className="fixed w-full h-screen left-0 top-0 bg-black/60 backdrop-blur-sm z-50 p-8 flex items-center justify-center">
            <div className="relative">
              <div className="absolute w-[30px] h-[30px] rounded-full shadow bg-black -right-[10px] -top-[10px] z-50 flex items-center justify-center cursor-pointer" onClick={handleClose}>
                <span className="absolute w-[16px] h-[2px] bg-white rotate-45" />
                <span className="absolute w-[16px] h-[2px] bg-white -rotate-45" />
              </div>
              <div className="overflow-y-auto max-h-[90vh] sm:w-[400px] md:w-[500px] lg:w-[600px] bg-white p-8 rounded-lg">
                <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
                  <div>
                    <h3 className="text-2xl font-bold">Register</h3>
                  </div>

                  {data?.getPromotionalEventBySlug.formFields.length > 0
                  && data?.getPromotionalEventBySlug.formFields.map((item) => (
                    <div key={item.label}>
                      <label className="block mb-2 font-[500] text-base" htmlFor={item.label}>
                        {item.label}
                      </label>

                      {item.type === 'text' && (
                      <>
                        <input
                          type="text"
                          id={item.label}
                          className="border p-3 rounded-lg block w-full"
                          {...register(item.label, {
                            required: item.required ? 'This field is required' : false,
                          })}
                        />
                        {errors[item.label] && (
                        <p className="text-red-500 text-sm">{errors[item.label].message}</p>
                        )}
                      </>
                      )}

                      {item.type === 'select' && Array.isArray(item.options) && (
                      <>
                        <select
                          id={item.label}
                          className="border p-3 rounded-lg block w-full"
                          {...register(item.label, {
                            required: item.required ? 'This field is required' : false,
                          })}
                          defaultValue=""
                        >
                          <option value="" disabled>
                            -- Select
                            {' '}
                            {item.label}
                            {' '}
                            --
                          </option>
                          {item.options.map((option, i) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <option key={`${item.label}_option_${i}`} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                        {errors[item.label] && (
                        <p className="text-red-500 text-sm">{errors[item.label].message}</p>
                        )}
                      </>
                      )}

                      {item.type === 'checkbox' && Array.isArray(item.options) && (
                        <>
                          <div className="flex flex-wrap gap-4">
                            {item.options.map((option, i) => {
                              const checkboxId = `${item.label}_${i}`;
                              return (
                                <div key={checkboxId} className="flex items-center gap-2 text-sm">
                                  <input
                                    type="checkbox"
                                    id={checkboxId}
                                    value={option.value}
                                    {...register(`${item.label}.${option.value}`)}
                                  />
                                  <label htmlFor={checkboxId}>{option.label}</label>
                                </div>
                              );
                            })}
                          </div>
                          {errors[item.label] && (
                          <p className="text-red-500 text-sm">{errors[item.label].message || 'Please select at least one option'}</p>
                          )}
                        </>
                      )}

                      {item.type === 'radio' && Array.isArray(item.options) && (
                      <>
                        <div className="flex gap-4">
                          {item.options.map((option, i) => {
                            const radioId = `${item.label}_${i}`;
                            return (
                              <div key={radioId} className="flex items-center gap-2 text-sm">
                                <input
                                  type="radio"
                                  id={radioId}
                                  value={option.value}
                                  {...register(item.label, {
                                    required: item.required ? 'This field is required' : false,
                                  })}
                                />
                                <label htmlFor={radioId}>{option.label}</label>
                              </div>
                            );
                          })}
                        </div>
                        {errors[item.label] && (
                        <p className="text-red-500 text-sm">{errors[item.label].message}</p>
                        )}
                      </>
                      )}
                    </div>
                  ))}

                  <button
                    type="submit"
                    className="mt-4 bg-[#045692] text-white px-6 py-2 rounded-md font-[600]"
                  >
                    Submit
                  </button>
                </form>

              </div>
            </div>
          </div>
        )
      }
      {
        data?.getPromotionalEventBySlug !== null ? (
          <>
            <div className="bg-[#fff]">
              {showLogin ? <Modal toggleModal={toggleModal} text="Login" /> : null}
              <div>
                <div className="relative z-10 py-[55px] xl:px-[8rem] lg:px-[8rem] px-[1rem] md:px-[3rem]">
                  <Image src={promoEventBanner} fill alt="banner" className="absolute -z-10 top-0 left-0" />

                  <div className="grid grid-cols-1 xl:grid-cols-[45%_40%] xl:gap-[6rem] md:gap-5 gap-4 items-center justify-between">
                    <div className="block xl:hidden flex flex-col items-center">
                      <span
                        className="flex items-center justify-start text-[#fff] w-[70%] md:w-[50%] h-[50px] mb-4 text-base leading-[24px] font-[700] bg-[#ed1c24]"
                        style={{ clipPath: 'polygon(0 0, 94% 0%, 100% 100%, 0% 100%)' }}
                      >
                        <Image
                          width={26}
                          height={37}
                          src={data?.getPromotionalEventBySlug?.type === 'webinar' ? videoIcon : speakerIcon}
                          alt="speaker-icon"
                          className="mx-3"
                        />
                        <span className="text-nowrap">
                          {data?.getPromotionalEventBySlug?.type === 'webinar' ? 'Online  webinar on' : 'Seminar on'}
                        </span>
                      </span>
                      <h2 className="text-[#282938] xl:text-5xl lg:text-4xl text-3xl text-center font-bold leading-snug mb-0">
                        {/* Road map to achieve success in GATE & ESE */}
                        {data?.getPromotionalEventBySlug.name}
                      </h2>
                    </div>
                    <div className="order-1 md:order-2 flex justify-center items-center mb-4 md:mb-0">
                      {data && data.getPromotionalEventBySlug?.speakers && data.getPromotionalEventBySlug?.speakers.length > 0 && (
                      <HomeTopSlider pageType="promotional-event" promoSlides={data?.getPromotionalEventBySlug?.speakers} />
                      )}
                    </div>

                    <div className="order-2 xl:order-1">
                      <div className="xl:block hidden">
                        <span
                          className="flex items-center justify-start text-[#fff] w-[70%] md:w-[50%] h-[50px] mb-4 text-base md:text-lg leading-[24px] font-[700] bg-[#ed1c24]"
                          style={{ clipPath: 'polygon(0 0, 94% 0%, 100% 100%, 0% 100%)' }}
                        >
                          <Image width={26} height={37} src={data?.getPromotionalEventBySlug?.type === 'seminar' ? speakerIcon : videoIcon} alt="speaker-icon" className="mx-3" />
                          {data?.getPromotionalEventBySlug?.type === 'webinar' ? 'Online  webinar on' : 'Seminar on'}
                        </span>
                        <h1 className="text-[#282938] xl:text-5xl lg:text-4xl text-3xl font-[700] leading-[1.3] mb-6">
                          {data?.getPromotionalEventBySlug.name}
                        </h1>
                      </div>

                      <div>
                        {
                    timer && eventType === 'webinar' ? (
                      <>
                        <p className="text-lg font-[500] mb-2">Our webinar will start in</p>
                        <CountDownTimer startDate={data?.getPromotionalEventBySlug.startDate} endDate={data?.getPromotionalEventBySlug.endDate} onEnd={handleTimer} />
                      </>
                    ) : (
                      data && (
                      <DatePlace
                        startDate={data?.getPromotionalEventBySlug.startDate}
                        endDate={data?.getPromotionalEventBySlug.endDate}
                        venue={data?.getPromotionalEventBySlug.venue}
                      />
                      )
                    )
                  }

                        <button
                          type="button"
                          className="bg-[#045692] text-[#fff] w-full mt-4 h-[63px] flex items-center justify-center rounded-[6px] text-lg xl:text-2xl font-[500] leading-[1.2]"
                          onClick={handleRegister}
                        >
                          <span>
                            {mutationLoading ? (
                              <svg
                                className="animate-spin h-6 w-6 text-white"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <circle
                                  className="opacity-25"
                                  cx="12"
                                  cy="12"
                                  r="10"
                                  stroke="currentColor"
                                  strokeWidth="4"
                                />
                                <path
                                  className="opacity-75"
                                  fill="currentColor"
                                  d="M12 2a10 10 0 0 1 10 10h-4a6 6 0 0 0-6-6V2z"
                                />
                              </svg>
                            ) : (status)}
                          </span>

                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {data && data.getPromotionalEventBySlug.features.length > 0 && (
                <div className="py-[55px] px-[1rem] md:px-[3rem] lg:px-[8rem]">
                  <h2 className="md:text-[35px] text-[30px] font-[700] text-center md:mb-[3rem] mb-8 leading-[1.3]">Why You Should Join</h2>
                  {
                data?.getPromotionalEventBySlug?.features.length > 4 ? (
                  <HorizontalScroll className="gap-2">
                    <div className="grid grid-flow-col lg:auto-cols-[32%] xl:auto-cols-[24%] md:auto-cols-[32%] auto-cols-[99%] gap-4">
                      {data.getPromotionalEventBySlug.features.length > 0 && data.getPromotionalEventBySlug.features.map((item, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <BenifitCard key={index} icon={item.image} title={item.name} description={item.description} />
                      ))}
                    </div>
                  </HorizontalScroll>
                ) : (
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    {data.getPromotionalEventBySlug.features.length > 0 && data.getPromotionalEventBySlug.features.map((item, index) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <BenifitCard key={index} icon={item.image} title={item.name} description={item.description} />
                    ))}
                  </div>
                )
              }
                </div>
                )}

                {/* about the webinar */}
                {data && (data?.getPromotionalEventBySlug.description ? (
                // eslint-disable-next-line react/no-danger
                  <div className="pt-[60px] pb-[75px] px-[1rem] md:px-[3rem] lg:px-[8rem] relative z-10" dangerouslySetInnerHTML={{ __html: data?.getPromotionalEventBySlug.description }}>
                    {/* <Image src={banner} fill className="absolute -z-10" />
                  <h2 className="md:text-[35px] text-[30px] font-[700] text-center md:mb-[3rem] mb-8 text-white leading-[1.3]">{`About the ${data?.getPromotionalEventBySlug?.type === 'webinar' ? 'Webinar' : 'Seminar'}`}</h2>
                  <div className="bg-white lg:p-20 p-10 rounded-[10px] shadow-md text-justify text-sm md:text-sm lg:text-base xl:text-base 2xl:text-base font-normal">{data?.getPromotionalEventBySlug.description}</div> */}
                  </div>
                ) : (
                  <div className="pt-[60px] pb-[75px] px-[1rem] md:px-[3rem] lg:px-[8rem] relative z-10">
                    <Image src={banner} fill className="absolute -z-10" />
                    <h2 className="md:text-[35px] text-[30px] font-[700] text-center md:mb-[3rem] mb-8 text-white leading-[1.3]">{`About the ${data?.getPromotionalEventBySlug?.type === 'webinar' ? 'Webinar' : 'Seminar'}`}</h2>
                    <div className="bg-white lg:p-20 p-10 rounded-[10px] shadow-md text-justify text-sm md:text-sm lg:text-base xl:text-base 2xl:text-base font-normal">{data?.getPromotionalEventBySlug.description}</div>
                  </div>
                ))}

                {
            data && data.getPromotionalEventBySlug?.speakers && data.getPromotionalEventBySlug?.speakers.length > 0 && (
              <div className="py-[55px] px-[1rem] md:px-[3rem] lg:px-[8rem]">
                <h2 className="md:text-[35px] text-[30px] font-[700] text-center md:mb-[3rem] mb-8 leading-[1.3]">{data?.getPromotionalEventBySlug?.speakers.length > 1 ? 'Our Speakers' : 'Our Speaker'}</h2>
                <div className="relative shadow-sm rounded-xl p-3 border border-[#c8c8c8]">
                  <Carousel autoPlay autoPlayInterval={5000} showArrows={false} length={data?.getPromotionalEventBySlug?.speakers.length}>
                    {
                      data && data.getPromotionalEventBySlug?.speakers && data?.getPromotionalEventBySlug?.speakers.map((item, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <div className="grid grid-cols-1 md:grid-cols-[30%_70%] gap-4" key={index}>
                          <div className="rounded-xl bg-[#bbdfff] relative w-full h-[250px] lg:h-[300px] md:h-[200px]">
                            <Image src={item.bannerImage} fill alt="slider-image" className="object-contain" />
                          </div>
                          <div className="pt-3 md:p-6 flex flex-col items-center md:items-start text-center md:text-left justify-start">
                            <h3 className="mb-2 font-[700] md:text-2xl">{item.name}</h3>
                            <h4 className="mb-3 font-[400] text-xl md:text-md lg:text-lg xl:text-lg">{item.bio}</h4>
                            <p className="text-sm md:text-sm lg:text-sm xl:text-base 2xl:text-base text-justify font-normal">
                              {item.description}
                            </p>
                          </div>

                        </div>
                      ))
                    }
                  </Carousel>
                </div>
              </div>

            )
          }

                {/* FAQ's */}
                {
            data && data.getPromotionalEventBySlug.faqs.length > 0 && (
              <div className="pt-[50px] px-[0.5rem] md:px-[2rem] lg:px-[8rem] bg-[#f5fbff] -mb-10">
                <h2 className="md:text-[35px] text-[30px] font-[700] text-center md:mb-[3rem] mb-8 leading-[1.3]">FAQ’s</h2>
                {data && (<FAQSection faqDataList={data?.getPromotionalEventBySlug.faqs} isTitle />)}
              </div>
            )
          }
                <div className="bg-[#045692] h-[50px] left-0 z-10 w-full" />
              </div>
            </div>
            <SuccessFormPopup
              pageType="promotional-event"
              isOpen={isPopupOpen}
              onClose={() => setPopupOpen(false)}
              title="Registered Successfully!"
              isPageNotRedirect
              message="We have sent an email to you with all the details."
              type="3"
            />
          </>
        ) : (
          <div className="h-screen w-full flex items-center justify-center">
            <NoDataFound noMsg={noMsg} />
          </div>
        )
      }

    </>

  );
}
EventRegisterForm.propTypes = {
  data: PropTypes.object,
};

export default EventRegisterForm;
